<template>
  <Toolbar class="p-mb-4 p-mt-4 p-p-2">
    <template #start>
      <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Branding') }}</div>
    </template>
  </Toolbar>

  <div class="p-grid">
    <div class="p-col-12 p-sm-12 p-md-6 p-lg-6">
      <div class="logo-upload-grid">
        <FileUploader :item="{ id : locationData?.id ? +locationData.id : null }"
                      @updated="onSiteLogoUpdated"
                      :maxWidth="600"
                      :maxHeight="200"
                      :itemHeight="100"
                      :wrapperClass="'p-fieldset p-p-3'"
                      :label="$t('locationSiteLogoLabel')"
                      :description="$t('locationSiteLogoHelp')"
                      field="site_logo_path"
                      :multiple="false"
                      previewClass="background-theme-color primary-text-color"
                      :currentUrl="locationSiteLogoSrc"
                      endpoint="location/upload-logo"
                      delete-endpoint="location/delete-logo"/>
      </div>
    </div>

    <div class="p-col-12 p-sm-12 p-md-6 p-lg-6">
      <div class="logo-upload-grid">
        <FileUploader :item="{ id : locationData?.id ? +locationData.id : null }"
                      :maxWidth="600"
                      :maxHeight="200"
                      :itemHeight="100"
                      :wrapperClass="'p-fieldset p-p-3'"
                      :label="$t('locationDocumentLogoLabel')"
                      :description="$t('locationDocumentLogoHelp')"
                      field="document_logo_path"
                      :multiple="false"
                      :currentUrl="locationDocumentLogoSrc"
                      endpoint="location/upload-logo"
                      delete-endpoint="location/delete-logo"/>
      </div>
    </div>
  </div>
</template>

<script>
import showErrorsMixins from "@/mixins/showErrorsMixins";
import formatMixins from "@/mixins/formatMixins";
import settings from "@/settings";
import FileUploader from "@/components/FileUploader";

export default {
  components: { FileUploader },
  emits: ['update-items'],
  mixins: [ showErrorsMixins, formatMixins ],
  props: {
    locationData: {
      type: Object,
      default: null,
    },
    locationIsLoading: {
      type: Boolean,
      default: false
    },
  },
	data() {
		return {
      submitted: false,
      isLoading: true,
      settings
		}
	},
  methods: {
    onSiteLogoUpdated({ data }) {
      if (!data) return

      if (+this.locationData?.id === +this.$store.getters.locationId) {
        this.$store.commit('SET_SITE_LOGO', data.site_logo_path)
      }
    },
  },
  computed: {
    locationSiteLogoSrc() {
      if (!this.locationData?.site_logo_path) return null

      const base = this.settings.apiEndPoint.replace(/\/$/, '')
      return base + '/api/location/site-logo?img=' + encodeURIComponent(this.locationData.site_logo_path)
    },

    locationDocumentLogoSrc() {
      if (!this.locationData?.document_logo_path) return null

      const base = this.settings.apiEndPoint.replace(/\/$/, '')
      return base + '/api/location/document-logo?img=' + encodeURIComponent(this.locationData.document_logo_path)
    },
  }
}
</script>

<style scoped lang="scss">
.settings-input {
  width: 100%;
  max-width: 280px;
  min-width: 0;
  box-sizing: border-box;
}

.settings-input :deep(.p-inputnumber) {
  width: 100%;
  max-width: 280px;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
}

.settings-input :deep(.p-inputnumber-input),
.settings-input :deep(input.p-inputtext) {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.settings-input :deep(.p-inputnumber-button-group) {
  flex: 0 0 auto;
}

.p-col-12,
.p-sm-12,
.p-md-4,
.p-lg-4,
.p-fieldset {
  min-width: 0;
}
</style>